import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'static';

import {
  StyledAddEventButton,
  StyledEventActions,
  StyledEventBlock,
  StyledEventCopy,
  StyledEventLinkNote,
  StyledEventMeta,
  StyledEventTitle,
  StyledRemoveEventButton,
  StyledViewEventLink,
} from './styled';

interface EventBlockProps {
  title: string;
  when: string;
  where?: string;
  accent?: string;
  included: boolean;
  url?: string | null;
  linkLoading: boolean;
  linkFailed: boolean;
  onAdd: () => void;
  onRemove: () => void;
}

const EventBlock: FC<EventBlockProps> = ({
  title,
  when,
  where,
  accent,
  included,
  url,
  linkLoading,
  linkFailed,
  onAdd,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <StyledEventBlock included={included} accent={accent}>
      <StyledEventCopy>
        <StyledEventTitle>{title}</StyledEventTitle>
        {when && <StyledEventMeta>📅 {when}</StyledEventMeta>}
        {where && <StyledEventMeta>📍 {where}</StyledEventMeta>}
        {included && linkFailed && !url && (
          <StyledEventLinkNote>
            {t('email.eventLinkUnavailable')}
          </StyledEventLinkNote>
        )}
      </StyledEventCopy>
      <StyledEventActions>
        {included ? (
          <>
            {url && (
              <StyledViewEventLink
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('email.viewEvent')}
              </StyledViewEventLink>
            )}
            <StyledRemoveEventButton
              type="button"
              aria-label={t('email.removeEventFromEmail')}
              title={t('email.removeEventFromEmail')}
              onClick={onRemove}
            >
              <CloseIcon />
            </StyledRemoveEventButton>
          </>
        ) : (
          <StyledAddEventButton
            type="button"
            onClick={onAdd}
            aria-busy={linkLoading}
          >
            {t('email.addEventToEmail')}
          </StyledAddEventButton>
        )}
      </StyledEventActions>
    </StyledEventBlock>
  );
};

export default EventBlock;
